export const EDITED_REPORT_DELIVERY_HOUR = 4 as const;
